import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";
import { SelectionModel } from "@angular/cdk/collections";
import { Component, Input, OnChanges, OnInit, ViewChild } from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatSort, Sort } from "@angular/material/sort";
import { MatTableDataSource, MatTableModule } from "@angular/material/table";
import { MatDialog } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { CommissionService } from "src/app/iap/services/commission.service";
import { DialogService } from "src/app/iap/services/dialog.service";
import { UserService } from "src/app/iap/services/user.service";
import { AuthenticationService } from "src/app/shared/auth/auth.service";
import { DisputedRequestSubmittedComponent } from "../disputed-requests-submitted/disputed-request-submitted.component";

import { Workbook } from "exceljs";
import * as fs from "file-saver";

import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import htmlToPdfmake from "html-to-pdfmake";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  ReactiveFormsModule,
} from "@angular/forms";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatSelectModule } from "@angular/material/select";
import { CommonModule } from "@angular/common";
import { MatInputModule } from "@angular/material/input";
import { MatIconModule } from "@angular/material/icon";

pdfMake.vfs = pdfFonts?.vfs;

@Component({
    selector: "app-claims-table-submitted",
    templateUrl: "./claims-table-submitted.component.html",
    styleUrls: ["./claims-table-submitted.component.scss"],
    imports: [
        ReactiveFormsModule,
        MatFormFieldModule,
        MatSelectModule,
        MatTableModule,
        MatPaginator,
        CommonModule,
        MatInputModule,
        MatIconModule,
    ],
    animations: [
        trigger("detailExpand", [
            state("collapsed, void", style({ height: "0px" })),
            state("expanded", style({ height: "*" })),
            transition("expanded <=> collapsed", animate("225ms cubic-bezier(0.4, 0.0, 0.2, 1)")),
            transition("expanded <=> void", animate("225ms cubic-bezier(0.4, 0.0, 0.2, 1)")),
        ]),
    ]
})
export class ClaimsTableSubmittedComponent implements OnInit, OnChanges {
  ELEMENT_DATA: any[];

  displayedColumns: string[] = [
    "Term",
    "StudentName",
    "SENECA_ID",
    "ProgramDescription",
    "SubmittedDate",
    "AgentName",
    "AgentDispute",
    "CommissionAmount",
    "CommissionStatusName",
    "requestStatusName",
    "VoucherNumber",
  ];

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  dataSource: MatTableDataSource<any>;
  dataSourceLoaded: MatTableDataSource<any>;
  selection = new SelectionModel<any>(true, []);

  selectedAgents: string;
  agentsList: string[];
  termList: any[];
  agencyID: string;
  selectedAgentOption: string;
  allSelected: boolean;
  isTableExpanded: boolean;
  agentID: Number;
  agencyName: string;
  selectedTermOption: string;
  term0: string;
  term1: string;
  commissionForm: FormGroup;

  constructor(
    private dialogService: DialogService,
    private commissionService: CommissionService,
    public dialog: MatDialog,
    private _snackBar: MatSnackBar,
    private router: Router,
    private authService: AuthenticationService,
    private userService: UserService,
    private formBuilder: FormBuilder
  ) {
    this.allSelected = true;
    this.isTableExpanded = false;
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(DisputedRequestSubmittedComponent, {
      maxWidth: "600px",
    });

    dialogRef.afterClosed().subscribe((result) => {
      console.log(`Dialog result: ${result}`);
    });
  }

  ngOnInit(): void {
    this.loadForm();

    let paramsObject = window.history.state.parameters;

    if (paramsObject) {
      if (paramsObject.term1) {
        this.selectedTermOption = paramsObject.term1;
        this.commissionForm.controls["termCtrl"].setValue(
          this.selectedTermOption
        );
      }
    }

    this.commissionService.getTerms().subscribe({
      next: (r) => {
        this.termList = r.recordset;
        if (!this.selectedTermOption) {
          this.selectedTermOption = this.termList[0].Name;
        }

        this.commissionForm.controls["termCtrl"].setValue(
          this.selectedTermOption
        );
      },
      error: (err) => {
        console.log(err);
      },
    });

    // add guard to not display the Commissions screen if you are not an agent
    if (
      this.authService.isAgencyAdmin() ||
      this.authService.isCommissionsUser()
    ) {
      let userInfo = this.authService.getUserInfo();
      console.log("User Info: ", userInfo);

      this.userService.getAgentAndAgencyID(userInfo.oid).subscribe((data) => {
        this.agentID = data.UserID;
        this.agencyID = data.AgencyID;
        this.agencyID = data.AgencyID;
        this.agencyName = data.Company_Name;

        this.commissionService
          .getAgentsByAgencyID(this.agencyID)
          .subscribe((data) => {
            this.agentsList = data;
            this.agencyName = data[0].Agency;
            this.refreshData(null);
          });
      });
    }
  }

  loadForm(): void {
    this.commissionForm = this.formBuilder.group({
      termCtrl: new FormControl(""),
    });
  }

  ngOnChanges() {}

  sortData(sort: Sort) {
    if (sort.active && sort.direction !== "") {
      this.dataSource.data.forEach((row: any) => {
        row.isExpanded = false;
      });

      return;
    }
  }

  refreshData(tabParentValue: any): void {
    if (tabParentValue) {
      this.term0 = tabParentValue.term0;
      this.term1 = tabParentValue.term1;
    }

    if (this.agencyID) {
      this.commissionService
        .getCommissionsSubmittedRequests(this.agencyID)
        .subscribe((data) => {
          this.ELEMENT_DATA = data;

          this.dataSource = new MatTableDataSource(this.ELEMENT_DATA);
          this.dataSourceLoaded = new MatTableDataSource(this.ELEMENT_DATA);

          let value = this.selectedTermOption;
          this.dataSource.filter = value.trim();

          this.dataSource.sort = this.sort;
          this.dataSource.paginator = this.paginator;
        });
    }
  }

  optionChanged(): void {
    this.applyFilterForBothControls();
  }

  optionChanged2(): void {
    this.applyFilterForBothControls();
  }

  applyFilterForBothControls() {
    this.dataSource.data = this.dataSourceLoaded.data;

    this.dataSource.filter = "";

    let dataSourceLocal = this.dataSource;

    if (this.allSelected && Number(this.selectedAgentOption) == 0) {
      let selectedTermOption = "";

      if (this.selectedTermOption) {
        selectedTermOption = this.selectedTermOption.trim().toLowerCase();
      }

      this.dataSource.filter = selectedTermOption;
    } else {
      let selectedTermOption = "";
      let selectedAgentOption = "";

      if (this.selectedTermOption) {
        selectedTermOption = this.selectedTermOption.trim();
      }

      if (this.selectedAgentOption) {
        selectedAgentOption = this.selectedAgentOption;
      }

      [selectedTermOption, selectedAgentOption].map(function (word: string) {
        dataSourceLocal.filter = word.trim().toLowerCase();
        dataSourceLocal.data = dataSourceLocal.filteredData;

        if (dataSourceLocal.paginator) {
          dataSourceLocal.paginator.firstPage();
        }
      });
    }
  }

  applyFilter(filterValue: string) {
    if (this.allSelected && filterValue === "0") {
      let selectedTermOption = "";

      if (this.selectedTermOption) {
        selectedTermOption = this.selectedTermOption.trim().toLowerCase();
      }

      this.dataSource.filter = selectedTermOption;
    } else {
      this.allSelected = false;
      this.dataSource.filter = filterValue.trim().toLowerCase();
    }
  }

  onSubmitClaim(): void {
    let value = this.selectedAgentOption;

    const confResult = this.dialogService.openDialog(
      "confirmChanges",
      "Confirm Action",
      "Are you sure you want to submit?",
      "Cancel",
      "Submit"
    );

    confResult.afterClosed().subscribe((dialogRes) => {
      if (dialogRes) {
        // Next steps implement usage with back end

        let RequestIds = [];

        let sel = this.selection.selected;

        sel.forEach(function (value) {
          RequestIds.push(value.RequestID);
        });

        this.commissionService
          .updateSubmittedRequests(RequestIds, this.agentID)
          .subscribe(
            (res) => {
              if (res) {
                this.refreshData(null);
              } else {
                this.dialogService.MessageBox(
                  "Error Updating the commissions status.",
                  "X",
                  5000,
                  "ErrorMessage"
                );
              }
            },
            (error) => {
              const res = this.dialogService.ErrorDialog(
                "Server Error",
                "Sorry, the system is unavailable at the moment.",
                "Close",
                "Try Again"
              );
              res.afterClosed().subscribe((dialogResult) => {
                if (dialogResult) {
                  this.callNext(200);
                }
              });
            }
          );
      }
    });
  }

  callNext(timeout) {
    setTimeout(() => {
      this.refreshData(null);
    }, timeout);
  }

  onDispute(id: string, requestTypeID: string, term: string): void {
    if (!this.term0) {
      this.term0 = "";
    }

    let url = "iap/commissions/disputed-request-submitted/";
    this.router.navigate([
      url,
      requestTypeID,
      id,
      term,
      this.term0,
      this.agencyID,
    ]);
  }

  viewDetail(row) {
    if (!this.term0) {
      this.term0 = "";
    }

    let url = "iap/commissions/view-requests/";
    this.router.navigate([
      url,
      row.RequestTypeID,
      row.ApplicationID,
      row.Term,
      this.term0,
      this.agencyID,
    ]);
  }

  ExportToExcel() {
    // Create workbook and worksheet
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet("ClaimsTable");

    const title = "Agency Commissions Report";

    // Add Row and formatting
    const titleRow = worksheet.addRow([title]);
    titleRow.font = {
      name: "Comic Sans MS",
      family: 4,
      size: 16,
      underline: "double",
      bold: true,
    };

    worksheet.addRow([]);

    let agencyNameTitle = "AgencyName: ";

    if (this.agencyName != undefined) {
      agencyNameTitle += this.agencyName;
    }

    const titleRow2 = worksheet.addRow([agencyNameTitle]);
    titleRow2.font = {
      name: "Comic Sans MS",
      family: 4,
      size: 12,
      underline: "double",
      bold: true,
    };

    const titleRow3 = worksheet.addRow(["Agency ID:" + this.agencyID]);
    titleRow3.font = {
      name: "Comic Sans MS",
      family: 4,
      size: 12,
      underline: "double",
      bold: true,
    };

    worksheet.addRow([]);

    const subTitleRow = worksheet.addRow(["Date : " + new Date()]);
    worksheet.addRow([]);

    const header = [
      "Student Name",
      "Student Number",
      "Application Number",
      "Program Name",
      "Term",
      "Agent Name",
      "Status Date",
      "Tuition Amount",
      "Commission Amount",
      "Commission Status",
      "Request Status",
      "Invoice",
    ];

    // Add Header Row
    const headerRow = worksheet.addRow([]);

    let headerRowNumber = headerRow.number;

    headerRow.font = {
      name: "Comic Sans MS",
      family: 4,
      size: 12,
      underline: "double",
      bold: true,
    };

    let j = 2;

    header.forEach((e) => {
      headerRow.getCell(j).value = e;
      j++;
    });

    // Cell Style : Fill and Border
    headerRow.eachCell((cell, number) => {
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFFFFF00" },
        bgColor: { argb: "FF0000FF" },
      };

      cell.border = {
        top: { style: "medium" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };
    });

    var newJSONData = this.dataSource.filteredData.map(function (o) {
      return {
        StudentName: o.StudentName,
        SenecaID: o.SENECA_ID,
        ApplicationID: o.ApplicationID,
        ProgramDescription: o.ProgramDescription,
        Term: o.Term,
        AgentName: o.AgentName,
        SubmittedDate: o.SubmittedDate,
        TuitionAmount: o.TuitionAmount,
        CommissionAmount: o.CommissionAmount,
        CommissionStatusName: o.CommissionStatusName,
        requestStatusName: o.requestStatusName,
        VoucherNumber: o.VoucherNumber,
      };
    });

    var dataForExcel = [];

    newJSONData.forEach((row: any) => {
      dataForExcel.push(Object.values(row));
    });

    let i = 2;

    dataForExcel.forEach((d) => {
      // Add Data and Conditional Formatting

      const row = worksheet.addRow([]);

      d.forEach((e) => {
        let cell = row.getCell(i);
        cell.value = e;
        cell.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };
        i++;
      });

      i = 2;

      const qty = row.getCell(4);
      let color = "FF99FF99";

      qty.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: color },
      };
    });

    //worksheet.getColumn(1).width = 40;
    worksheet.getColumn(2).width = 40;
    worksheet.getColumn(3).width = 20;
    worksheet.getColumn(4).width = 25;
    worksheet.getColumn(5).width = 20;
    worksheet.getColumn(6).width = 30;
    worksheet.getColumn(7).width = 20;
    worksheet.getColumn(8).width = 20;
    worksheet.getColumn(9).width = 25;
    worksheet.getColumn(10).width = 25;
    worksheet.getColumn(11).width = 25;
    worksheet.getColumn(12).width = 25;
    worksheet.getColumn(13).width = 25;

    // Footer Row
    const footerRow = worksheet.addRow([]);

    footerRow.getCell(2).fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FFCCFFE5" },
    };

    // Merge Cells
    worksheet.mergeCells(`B${footerRow.number}:N${footerRow.number}`);

    let footerRowNumber = footerRow.number;

    for (let k = headerRowNumber; k <= footerRowNumber; k++) {
      let row = worksheet.getRow(k);

      if (k == headerRowNumber) {
        row.getCell(2).border = {
          top: { style: "medium" },
          left: { style: "medium" },
          bottom: { style: "medium" },
          right: { style: "thin" },
        };
        row.getCell(13).border = {
          top: { style: "medium" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "medium" },
        };
      } else if (k == footerRowNumber) {
        row.getCell(2).border = {
          top: { style: "thin" },
          left: { style: "medium" },
          bottom: { style: "medium" },
          right: { style: "thin" },
        };
        row.getCell(13).border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "medium" },
          right: { style: "medium" },
        };
      } else {
        row.getCell(2).border = {
          top: { style: "thin" },
          left: { style: "medium" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };
        row.getCell(13).border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "medium" },
        };
      }
    }

    let row = worksheet.getRow(footerRowNumber);
    for (let k = 2; k <= 13; k++) {
      if (k == 2) {
        row.getCell(k).border = {
          top: { style: "thin" },
          left: { style: "medium" },
          bottom: { style: "medium" },
          right: { style: "thin" },
        };
      } else if (k == 13) {
        row.getCell(k).border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "medium" },
          right: { style: "medium" },
        };
      } else
        row.getCell(k).border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "medium" },
          right: { style: "thin" },
        };
    }

    row.getCell(2).border.left.style = "medium";

    // Generate Excel File with given name
    workbook.xlsx.writeBuffer().then((data: any) => {
      const blob = new Blob([data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      fs.saveAs(blob, "ClaimsTable.xlsx");
    });
  }

  ExportToPDF() {
    var table = this.CreateHTMLTable();

    var html = htmlToPdfmake(table);

    const documentDefinition = {
      footer: function (currentPage, pageCount) {
        return [
          {
            text: "Page " + currentPage.toString() + " of " + pageCount,
            alignment: "center",
          },
        ];
      },
      content: html,
      pageOrientation: "landscape",
      pageMargins: [20, 20, 20, 30],
      defaultStyle: {
        fontSize: 9,
      },
    };

    pdfMake.createPdf(documentDefinition as any).open();
  }

  CreateHTMLTable(): any {
    var table = "<table border='1' style='width:100%;word-break:break-word;'>";

    let agencyID = "";
    let agencyName = "";

    if (this.agencyID != undefined) {
      agencyID = this.agencyID;
    }

    if (this.agencyName != undefined) {
      agencyName = this.agencyName;
    }

    table += "<tr>";
    table += `<td colspan="${12}" >Agency Name: ${agencyName}</td>`;
    table += "</tr>";
    table += "<tr>";
    table += `<td colspan="${12}" >Agency ID: ${agencyID}</td>`;
    table += "</tr>";
    table += "<tr>";
    table += "<th >Student Name</th>";
    table += "<th >Student Number</th>";
    table += "<th >Application Number</th>";
    table += "<th >Program Name</th>";
    table += "<th >Term</th>";
    table += "<th >Agent Name</th>";
    table += "<th >Submitted Date</th>";
    table += "<th >Tuition Amount</th>";
    table += "<th >Commision Amount</th>";
    table += "<th >Commision Status</th>";
    table += "<th >Request Status</th>";
    table += "<th >Invoice</th>";
    table += "</tr>";

    this.dataSource.filteredData.forEach(function (row) {
      table += "<tr>";
      table += "<td>" + row.StudentName + "</td>";
      table += "<td>" + row.SENECA_ID + "</td>";
      table += "<td>" + row.ApplicationID + "</td>";
      table += "<td>" + row.ProgramDescription + "</td>";
      table += "<td>" + row.Term + "</td>";
      table += "<td>" + row.AgentName + "</td>";
      table += "<td>" + row.SubmittedDate + "</td>";
      table += "<td>" + row.TuitionAmount + "</td>";
      table += "<td>" + row.CommissionAmount + "</td>";
      table += "<td>" + row.CommissionStatusName + "</td>";
      table += "<td>" + row.requestStatusName + "</td>";
      table += "<td>" + row.VoucherNumber + "</td>";
      table += "</tr>";
    });

    table += "</table>";

    return table;
  }
}
